SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};
SCM.Utilities.LazyLoad = (function () {
    const DefaultLazyClass = 'lazy';
    const LazyLoadInitClass = 'lazyLoadInit';
    var _disabled = false;

    return {
        init: init,
        updateImageSrc: updateImageSrc,
        disable: disable,
        enable: enable
    };

    function init(lazyClass) {
        try {
            lazyClass = lazyClass || DefaultLazyClass;

            var uninitializedLazyImagesSelector = 'img.' + lazyClass + ':not(.' + LazyLoadInitClass + ')';
            var lazyImages =
                [].slice.call(document.querySelectorAll(uninitializedLazyImagesSelector));

            if (!lazyImages.length) {
                return;
            }

            if (browserSupportsIntersectionObserver()) {
                observerLazyLoad(lazyImages, lazyClass);
            } else {
                legacyLazyLoad(lazyImages, lazyClass);
            }
        } catch (ex) {
            console.error('Exception during SCM.Utilities.LazyLoad.init()', ex);
        }

    }

    function browserSupportsIntersectionObserver() {
        return 'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype &&
            'isIntersecting' in window.IntersectionObserverEntry.prototype;
    }

    function observerLazyLoad(lazyImages, lazyClass) {
        var observerHandler = function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && !_disabled) {
                    var lazyImage = entry.target;
                    updateImageSrc(lazyImage);
                    lazyImage.classList.remove(lazyClass);
                    observer.unobserve(lazyImage);
                }
            });
        };

        // Trigger the image load when the img element is within 200px of the viewport
        var lazyImageObserver = new IntersectionObserver(observerHandler, { rootMargin: '200px 0px 200px 0px' });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
            lazyImage.classList.add(LazyLoadInitClass);
        });
    }

    function disable() {
        _disabled = true;
    }

    function enable() {
        _disabled = false;
    }

    function legacyLazyLoad(lazyImages, lazyClass) {
        var active = false;

        var lazyLoad = function () {
            if (active === false) {
                active = true;

                setTimeout(function () {
                    lazyImages.forEach(function (lazyImage) {
                        if (!_disabled && lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== 'none') {
                            updateImageSrc(lazyImage);
                            lazyImage.classList.remove(lazyClass);

                            lazyImages = lazyImages.filter(function (image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener('scroll', lazyLoad);
                                window.removeEventListener('resize', lazyLoad);
                                window.removeEventListener('orientationchange', lazyLoad);
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        };

        document.addEventListener('scroll', lazyLoad);
        window.addEventListener('resize', lazyLoad);
        window.addEventListener('orientationchange', lazyLoad);

        lazyImages.forEach(function(lazyImage) {
            lazyImage.classList.add(LazyLoadInitClass);
        });

    }

    function updateImageSrc(lazyImage) {
        var src = lazyImage.dataset.src || lazyImage.dataset.original;
        if (src) {
            lazyImage.src = src;
        }
        if (lazyImage.dataset.srcset) {
            lazyImage.srcset = lazyImage.dataset.srcset;
        }
    }

})();
